import React, { Component } from "react";
import { Spin, Radio, Space, message, DatePicker, Checkbox } from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";

export default class AdditionalHealthInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      do_you_have_assistive_technology: "",
      have_you_been_diagnosed_with_hearing_loss: "",
      are_you_attended_speech_therapy_or_speech_pathologist: "",
      yes_currently_start_date: null,
      yes_in_past_start_date: null,
      yes_in_past_end_date: null,
      additional_health_info_apply_to_you_list: [],
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (
                item.field == "Do you require the use of assistive technology?"
              ) {
                this.setState({ do_you_have_assistive_technology: item.value });
              }
              if (item.field == "Have you been diagnosed with hearing loss?") {
                this.setState({
                  have_you_been_diagnosed_with_hearing_loss: item.value,
                });
              }
              if (
                item.field ==
                "Are you currently or in the past attended speech therapy / seen a speech pathologist?"
              ) {
                this.setState({
                  are_you_attended_speech_therapy_or_speech_pathologist:
                    item.value,
                });
              }
              if (
                item.field ==
                "Are you currently or in the past attended speech therapy, if Yes currently Start Date"
              ) {
                this.setState({
                  yes_currently_start_date: item.value
                    ? dayjs(item.value)
                    : null,
                });
              }
              if (
                item.field ==
                "Are you currently or in the past attended speech therapy, if Yes in the past Start Date"
              ) {
                this.setState({
                  yes_in_past_start_date: item.value ? dayjs(item.value) : null,
                });
              }
              if (
                item.field ==
                "Are you currently or in the past attended speech therapy, if Yes in the past End Date"
              ) {
                this.setState({
                  yes_in_past_end_date: item.value ? dayjs(item.value) : null,
                });
              }
              if (
                item.field ==
                "Please select any and all options that may apply to you. If none apply, please select 'None of the above'"
              ) {
                this.setState({
                  additional_health_info_apply_to_you_list: item.value
                    ? JSON.parse(item.value)
                    : [],
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  save = () => {
    if (!this.state.do_you_have_assistive_technology) {
      message.warning(
        "Please select value of 'Do you require the use of assistive technology' field"
      );
      return;
    }
    if (!this.state.have_you_been_diagnosed_with_hearing_loss) {
      message.warning(
        "Please select value of 'Have you been diagnosed with hearing loss' field"
      );
      return;
    }
    if (!this.state.are_you_attended_speech_therapy_or_speech_pathologist) {
      message.warning(
        "Please select value of 'Are you currently or in the past attended speech therapy / seen a speech pathologist' field"
      );
      return;
    }
    if (this.state.additional_health_info_apply_to_you_list.length == 0) {
      message.warning(
        "Please select value of 'Please select any and all options that may apply to you. If none apply, please select 'None of the above' field"
      );
      return;
    }
    let questions = [
      {
        parent_field: "Do you require the use of assistive technology?",
        field: "Do you require the use of assistive technology?",
        value: this.state.do_you_have_assistive_technology
          ? this.state.do_you_have_assistive_technology
          : "No",
      },
      {
        parent_field: "Have you been diagnosed with hearing loss?",
        field: "Have you been diagnosed with hearing loss?",
        value: this.state.have_you_been_diagnosed_with_hearing_loss
          ? this.state.have_you_been_diagnosed_with_hearing_loss
          : "No",
      },
      {
        parent_field:
          "Are you currently or in the past attended speech therapy / seen a speech pathologist?",
        field:
          "Are you currently or in the past attended speech therapy / seen a speech pathologist?",
        value: this.state.are_you_attended_speech_therapy_or_speech_pathologist,
      },
      {
        parent_field:
          "Are you currently or in the past attended speech therapy, if Yes currently Start Date",
        field:
          "Are you currently or in the past attended speech therapy, if Yes currently Start Date",
        value: this.state.yes_currently_start_date
          ? dayjs(this.state.yes_currently_start_date).format("MM/DD/YYYY")
          : null,
      },
      {
        parent_field:
          "Are you currently or in the past attended speech therapy, if Yes in the past Start Date",
        field:
          "Are you currently or in the past attended speech therapy, if Yes in the past Start Date",
        value: this.state.yes_in_past_start_date
          ? dayjs(this.state.yes_in_past_start_date).format("MM/DD/YYYY")
          : null,
      },
      {
        parent_field:
          "Are you currently or in the past attended speech therapy, if Yes in the past End Date",
        field:
          "Are you currently or in the past attended speech therapy, if Yes in the past End Date",
        value: this.state.yes_in_past_end_date
          ? dayjs(this.state.yes_in_past_end_date).format("MM/DD/YYYY")
          : null,
      },
      {
        parent_field:
          "Please select any and all options that may apply to you. If none apply, please select 'None of the above'",
        field:
          "Please select any and all options that may apply to you. If none apply, please select 'None of the above'",
        value: JSON.stringify(
          this.state.additional_health_info_apply_to_you_list
        ),
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "6",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(9);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChangeAdditionalHealthApplyOptions = (e) => {
    let value = e.target.value;
    let tempArr = this.state.additional_health_info_apply_to_you_list;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ additional_health_info_apply_to_you_list: newArray });
    } else {
      tempArr.push(value);
      this.setState({ additional_health_info_apply_to_you_list: tempArr });
    }
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment();
    };
    return (
      <div>
        <div className="header">
          <h3>ADDITIONAL HEALTH INFORMATION</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                Do you require the use of assistive technology, such as screen
                readers, magnifiers, or alternative keyboards?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    do_you_have_assistive_technology: event.target.value,
                  })
                }
                value={this.state.do_you_have_assistive_technology}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Have you been diagnosed with hearing loss?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    have_you_been_diagnosed_with_hearing_loss:
                      event.target.value,
                  })
                }
                value={this.state.have_you_been_diagnosed_with_hearing_loss}
              >
                <Space direction="horizontal">
                  <Radio value={"Yes"}>Yes</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Are you currently or in the past attended speech therapy/ seen a
                speech pathologist? <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(event) =>
                  this.setState({
                    are_you_attended_speech_therapy_or_speech_pathologist:
                      event.target.value,
                    yes_currently_start_date: null,
                    yes_in_past_start_date: null,
                    yes_in_past_end_date: null,
                  })
                }
                value={
                  this.state
                    .are_you_attended_speech_therapy_or_speech_pathologist
                }
              >
                <Space direction="horizontal">
                  <Radio value={"Yes, currently"}>Yes, currently</Radio>
                  <Radio value={"Yes, in the past"}>Yes, in the past</Radio>
                  <Radio value={"No"}>No</Radio>
                </Space>
              </Radio.Group>
            </div>
            {this.state.are_you_attended_speech_therapy_or_speech_pathologist ==
              "Yes, currently" && (
              <div>
                <div className="col-lg-9">
                  <div className="form-group">
                    <label className="mb-2 input-heading">Start Date</label>
                    <br />
                    <DatePicker
                      onChange={(date, dateString) =>
                        this.setState({
                          yes_currently_start_date: date,
                        })
                      }
                      format={"MM/DD/YYYY"}
                      disabledDate={disabledDate}
                      value={this.state.yes_currently_start_date}
                      style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {this.state.are_you_attended_speech_therapy_or_speech_pathologist ==
              "Yes, in the past" && (
              <div>
                <div className="col-lg-9">
                  <div className="form-group">
                    <label className="mb-2 input-heading">
                      Start Date
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <DatePicker
                      onChange={(date, dateString) =>
                        this.setState({
                          yes_in_past_start_date: date,
                        })
                      }
                      format={"MM/DD/YYYY"}
                      disabledDate={disabledDate}
                      value={this.state.yes_in_past_start_date}
                      style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="mb-2 input-heading">
                      End Date
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <DatePicker
                      onChange={(date, dateString) =>
                        this.setState({
                          yes_in_past_end_date: date,
                        })
                      }
                      format={"MM/DD/YYYY"}
                      disabledDate={disabledDate}
                      value={this.state.yes_in_past_end_date}
                      style={{
                        width: "100%",
                        height: 55,
                        maxWidth: 500,
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="form-group">
              <label className="input-heading">
                Please select any and all options that may apply to you. If none
                apply, please select 'None of the above'{" "}
                <span className="text-danger">*</span>
              </label>
              <ul>
                <li>
                  <Checkbox
                    value={"Hearing impaired / wear a hearing aid"}
                    onChange={this.onChangeAdditionalHealthApplyOptions}
                    checked={
                      this.state.additional_health_info_apply_to_you_list.includes(
                        "Hearing impaired / wear a hearing aid"
                      )
                        ? true
                        : false
                    }
                  >
                    Hearing impaired / wear a hearing aid
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"Vision impaired / wear glasses"}
                    onChange={this.onChangeAdditionalHealthApplyOptions}
                    checked={
                      this.state.additional_health_info_apply_to_you_list.includes(
                        "Vision impaired / wear glasses"
                      )
                        ? true
                        : false
                    }
                  >
                    Vision impaired / wear glasses
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    value={"Currently wearing a dental appliance or dentures"}
                    onChange={this.onChangeAdditionalHealthApplyOptions}
                    checked={
                      this.state.additional_health_info_apply_to_you_list.includes(
                        "Currently wearing a dental appliance or dentures"
                      )
                        ? true
                        : false
                    }
                  >
                    Currently wearing a dental appliance or dentures
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    checked={
                      this.state.additional_health_info_apply_to_you_list.includes(
                        "None of the above"
                      )
                        ? true
                        : false
                    }
                    value={"None of the above"}
                    onChange={this.onChangeAdditionalHealthApplyOptions}
                  >
                    None of the above
                  </Checkbox>
                </li>
              </ul>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(6)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
